import { useContext } from "react";
import AuthContext from "../context/AuthContext";

const useAuth = () => {
  const { user, token, updatePreference, authReady } = useContext(AuthContext);
  return [user, token, updatePreference, authReady];
};

export default useAuth;
